import { widgetSizeParams} from "./mutations/widgetSizeParams";
import { i18n } from "@/entries/widget/i18n";

const isApollo = window.location.host.includes('apollo')

export const mutations = {
    setMainParamsFromBack(state, value) {
        state.showStartPage = value.showStartPage
        state.payinCrypto = value.payinCrypto
        state.payinFiat = value.payinFiat
        state.payoutCrypto = value.payoutCrypto
        state.payinCryptoType = value.payinCryptoType
        state.organization = value.organization
        state.orderId = value.orderId
        state.payoutId = value.payoutId
        state.fiatId = value.fiatId // параметр получается либо из адресной строки либо генерируется в файле main.vue

        if (value.fiatSettings?.currencies) {
            const location = window.location
            const { ancestorOrigins= [] } = location

            // надо убрать для albertcrypto хоста рубли в фиатных платежах
            if (ancestorOrigins) {
                const albertCryptoHost = Object.keys(ancestorOrigins).some(key => ancestorOrigins[key].includes('albertcrypto.pro'))

                if (albertCryptoHost) {
                    value.fiatSettings.currencies = value.fiatSettings.currencies.filter(curr => curr !== 'RUB')
                }
            }

            value.fiatSettings.currencies = value.fiatSettings.currencies.map(currency => {
                return {
                    id: currency,
                    value: currency,
                    currency: currency,
                    symbol: currency === 'USD' ? '$' : ( currency === 'RUB' ?  '₽' : '€')
                }
            })
        }

        state.fiatSettings = value.fiatSettings

        const isThemeValid =( theme )=> ['light', 'dark'].includes(theme) //проверяем что пользователь правильно назвал тему при создании виджета
        const themeAttributeName = isApollo ? 'widget-theme-apollo' : 'widget-theme'
        if (!!value.theme && isThemeValid(value.theme)) {
            state.theme = value.theme
            document.documentElement.setAttribute(themeAttributeName, value.theme)
        } else {
            state.theme = document.documentElement.getAttribute(themeAttributeName)
        }

        state.payinCryptoInvoicePayerEmailAllow = value.payinCryptoInvoicePayerEmailAllow
        state.payinCryptoInvoicePayerEmailRequired = value.payinCryptoInvoicePayerEmailRequired

        state.payinCryptoInvoiceFree = value.payinCryptoInvoiceFree

        state.payinCryptoInvoiceCurrencies = value.payinCryptoInvoiceCurrencies
        state.payinCryptoCurrenciesTo = value.payinCryptoCurrenciesTo

        state.payoutCryptoPayerEmailAllow = value.payoutCryptoPayerEmailAllow
        state.payoutCryptoPayerEmailRequired = value.payoutCryptoPayerEmailRequired

        state.payoutCryptoCurrenciesFrom = value.payoutCryptoCurrenciesFrom.reduce((acc, item) => {
            const currencyUsed = acc.some(({ currencyId }) => currencyId === item.currencyId )

            if (!currencyUsed) {
                acc.push(item)
            }

            return acc
        }, [])

        state.payoutCryptoCurrenciesTo = value.payoutCryptoCurrenciesTo
        state.payoutCryptoAmountFrom = value.payoutCryptoAmountFrom
    },
    setOrderId(state, value) {
        state.orderId = value
    },
    setPersonalUserInfo(state, value) {
        state.personalUserInfo = value
    },
    setOpenedModal(state, modalName) {
        state.openedModal.name = modalName;
    },
    setOpenedModalPayload(state, payload) {
        state.openedModal.payload = payload;
    },
    setWidgetSizes(state) {
        const url = new URL(window.location.href);
        if (url.searchParams.has('withoutFooter')) {
            state.withoutFooter = true
        }
        if (url.searchParams.has('withoutTitle')) {
            state.withoutTitle = true
        }

        const urlSearchParams = new URLSearchParams(window.location.search);

        state.widgetSize = urlSearchParams.get('widgetSize') || 'large';

        widgetSizeParams.setWidgetSizes(state, state.widgetSize)
    },
    setWidgetTheme(state, theme) {
        state.theme = theme
        const themeAttributeName = isApollo ? 'widget-theme-apollo' : 'widget-theme'
        document.documentElement.setAttribute(themeAttributeName, theme)
    },
    setLanguage(state, lang) {
        i18n.locale = lang

        state.lang = lang
    },

    //for INVOICE
    setInvoiceInfo(state, value) {
        state.invoiceInfo = value
    },
    setOrderInfo(state, value = undefined) {
        state.orderInfo = value
        // if (state.orderInfo) {
        //     state.orderInfo.transactions = [
        //         {
        //             "id": "fcdbfc33-bfaf-4dc0-8d48-861488209e01",
        //             "organizationId": "1f07eb01-5fd8-4e05-89b5-bebcd1d1fc39",
        //             "type": "in",
        //             "withdrawalId": null,
        //             "orderId": "3d9ce86e-1a16-4679-8a3b-3f4c19ae6fbd",
        //             "currencyId": "03dbd2a5-3148-413d-a26c-8de1103d34a5",
        //             "networkId": "6b976e2c-cf6e-4601-ba7e-f3df5af86af7",
        //             "amount": 0.1,
        //             "addressId": "534cfe6b-d403-4d79-9c5e-7c4c6fe8ddeb",
        //             "recipients": "0x4bC0e3925EBcB1f42311Befe24fE8360F217aAF6",
        //             "senders": [
        //                 "0x9D9d71514AeE30ac2B632A6114bB450B18d615F3"
        //             ],
        //             "transactionHash": "0x00dbb4387a230c675218842f0c345485386af5ea9114093c11098694cb242a1c",
        //             "transactionIndex": null,
        //             "confirmationsExpected": 15,
        //             "confirmations": 15,
        //             "status": "processed",
        //             "confirmed": true,
        //             "priceUSD": "0.9996476822795105",
        //             "amountUSD": "0.09996476822795105",
        //             "inUnfreezeLag": false,
        //             "risks": null,
        //             "operationId": "8570ac34-4838-496e-8168-79c648754c3a",
        //             "parentOperationId": null,
        //             "createdAt": "2025-01-15T10:11:03.290Z",
        //             "updatedAt": "2025-01-15T10:11:47.785Z",
        //             "deletedAt": null
        //         }
        //     ]
        // }
    }
}
